// extracted by mini-css-extract-plugin
module.exports = {"clip-board":"src-com-components-clip-board-index__clip-board"};